/** @paper-design/shaders-react@0.0.60 */
import { MeshGradient as MeshGradient1 } from '@paper-design/shaders-react';

/**
 * Code exported from Paper
 * https://app.paper.design/file/01K81BFS0KDCZKY4RRBAHH5SPB?node=01K86JDG2TPK5N464CTW24E0QP
 * on Oct 22, 2025 at 4:23 PM.
 */
export default function MeshGradient() {
  return <MeshGradient1 speed={1} colors={['#010C22', '#5A739C']} distortion={0.8} swirl={0} grainMixer={0} grainOverlay={0} style={{ height: '320px', width: '480px' }} />;
}
